'use strict';
module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
};



//////////////////
// WEBPACK FOOTER
// ./~/is-alphanumeric/index.js
// module id = 188
// module chunks = 96961042003272 139266963665775